import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import Panel from "./../";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Example = makeShortcode("Example");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <nav {...{
      "className": "table-of-contents"
    }}><ol parentName="nav" {...{
        "className": "toc-level toc-level-1"
      }}><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#normal"
          }}>{`Normal`}</a></li></ol></nav>
    <h2 {...{
      "id": "normal"
    }}>{`Normal`}</h2>
    <Example mdxType="Example">
  <Panel border mdxType="Panel">Et helt vanlig panel med innhold.</Panel>
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Panel border>Et helt vanlig panel med innhold.</Panel>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      